import React, { Component } from 'react';
import Page from '../../../components/Page';
import { Segment, Header, Button, Input, Icon, Message, Confirm } from 'semantic-ui-react';
import { get, post } from '../../../util/api';
import MyMenu from '../menu';

class PlatformSecret extends Component {
	state = {
		secret: '',
		loading: true,
		copied: false,
		confirmOpen: false,
		error: '',
	};

	componentDidMount() {
		this.loadSecret();
	}

	loadSecret = async () => {
		try {
			this.setState({ loading: true, error: '' });
			const res = await get('/live/product/platform-secret');
			if (res.success) {
				this.setState({ secret: res.data.secret, loading: false });
			} else {
				this.setState({ error: res.message || 'Secret alınamadı.', loading: false });
			}
		} catch (e) {
			this.setState({ error: 'Secret alınamadı.', loading: false });
		}
	};

	regenerate = async () => {
		try {
			this.setState({ loading: true, confirmOpen: false, error: '' });
			const res = await post('/live/product/platform-secret/regenerate', {});
			const data = res.data || res;
			if (data.success) {
				this.setState({ secret: data.data.secret, loading: false });
			} else {
				this.setState({ error: data.message || 'Yenileme başarısız.', loading: false });
			}
		} catch (e) {
			this.setState({ error: 'Yenileme başarısız.', loading: false });
		}
	};

	copyToClipboard = () => {
		navigator.clipboard.writeText(this.state.secret).then(() => {
			this.setState({ copied: true });
			setTimeout(() => this.setState({ copied: false }), 2000);
		});
	};

	render() {
		const { secret, loading, copied, confirmOpen, error } = this.state;

		return (
			<Page title="Platform API" icon="key" flex>
				<MyMenu activeItem="platform-secret">
					<Page.Wrap>
						<Segment>
							<Header as="h3">
								<Icon name="key" />
								<Header.Content>
									Platform API Secret
									<Header.Subheader>Bu anahtarı dış platformlara vererek DialogTab kanallarınıza erişim sağlayabilirsiniz.</Header.Subheader>
								</Header.Content>
							</Header>

							{error && <Message negative content={error} />}

							<div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '16px' }}>
								<Input
									value={loading ? 'Yükleniyor...' : secret}
									readOnly
									fluid
									style={{ flex: 1, fontFamily: 'monospace' }}
									action
								>
									<input />
									<Button
										icon={copied ? 'check' : 'copy'}
										color={copied ? 'green' : undefined}
										onClick={this.copyToClipboard}
										disabled={loading}
										title="Kopyala"
									/>
								</Input>
								<Button
									icon="refresh"
									color="orange"
									onClick={() => this.setState({ confirmOpen: true })}
									disabled={loading}
									title="Yeniden Üret"
								/>
							</div>

							<Message info size="small" style={{ marginTop: '16px' }}>
								<Message.Content>
									Secret yenilenirse eski anahtarı kullanan tüm bağlantılar kesilir.
								</Message.Content>
							</Message>

							<Confirm
								open={confirmOpen}
								content="Secret yenilenecek. Eski anahtarı kullanan bağlantılar çalışmayı durduracak. Devam etmek istiyor musunuz?"
								confirmButton="Evet, Yenile"
								cancelButton="İptal"
								onCancel={() => this.setState({ confirmOpen: false })}
								onConfirm={this.regenerate}
							/>
						</Segment>
					</Page.Wrap>
				</MyMenu>
			</Page>
		);
	}
}

export default PlatformSecret;
